import cardMixin from './card-mixin';
import clickOutMixin from './clickout';
import dropdownMixin from './dropdown';
import formMixin from './form';
import formCustomMixin from './form-custom';
import formOptionsMixin from './form-options';
import formRadioCheckMixin from './form-radio-check';
import formSizeMixin from './form-size';
import formStateMixin from './form-state';
import idMixin from './id';
import listenOnRootMixin from './listen-on-root';
import paginationMixin from './pagination';
import toolpopMixin from './toolpop';

export { cardMixin, clickOutMixin, dropdownMixin, formMixin, formCustomMixin, formOptionsMixin, formRadioCheckMixin, formSizeMixin, formStateMixin, idMixin, listenOnRootMixin, paginationMixin, toolpopMixin };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/mixins/index.js
// module id = 10
// module chunks = 0